import { Switch, Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Sidebar from 'components/Sidebar';
import ScrollToTop from 'components/ScrollToTop';
import ForgotPassword from 'pages/ForgotPassword';
import DeleteAccount from 'pages/DeleteAccount';
import Login from 'pages/Login';
import Logout from 'pages/Logout';
import Tables from 'pages/Tables';
import Classe from 'pages/Classe';
import Suivi from 'pages/Suivi'
import FilAnnuel from 'pages/FilAnnuel'
import Note from 'pages/Note';
import NotificationContainer from 'components/NotificationContainer';
import history from 'components/history';

//ADMIN PAGE
import SideBarAdmin from 'components/SideBarAdmin';
import LoginAdmin from 'pages/LoginAdmin';
import Dashboard from 'pages/Dashboard';

// Tailwind CSS Style Sheet
import 'assets/styles/tailwind.css';
import "@material-tailwind/react/tailwind.css";
import 'react-notifications/lib/notifications.css';
import 'assets/styles/notifications.css';

import Cookies from 'universal-cookie';
import { hasAuthenticatedSession } from './utils/authentication';

function App() {

    const cookies = new Cookies();
    const currentUser = useSelector(state => state.userGlobal.user);

    const fakeAuth = {
      isAuthenticated: hasAuthenticatedSession(cookies.get('authenticated'), currentUser)
      ,isAuthenticatedAdmin: hasAuthenticatedSession(cookies.get('authenticated_admin'), currentUser, true)
      ,rules: cookies.get('rules')
      ,filter: cookies.get('filter')
    }

    return (
        <>
            {fakeAuth.isAuthenticated && (<Sidebar />)}
            {fakeAuth.isAuthenticatedAdmin && (<SideBarAdmin />)}

            <div>
                <NotificationContainer />
                <ScrollToTop history={history}>
                    <Switch>
                        <Route
                            exact
                            path="/"
                            render={() => (
                                fakeAuth.isAuthenticated
                                    ? <Redirect to="/compte" />
                                    : <Login />
                            )}
                        />
                        <Route
                            exact
                            path="/admin_dashboard"
                            render={() => (
                                fakeAuth.isAuthenticatedAdmin
                                    ? <Redirect to="/dashboard" />
                                    : <LoginAdmin />
                            )}
                        />
                        <Route exact path="/logout" component={Logout} />
                        <Route exact path="/change_mdp" component={ForgotPassword} />
                        <Route exact path="/delete_account" component={DeleteAccount} />

                        {fakeAuth.isAuthenticated && (<Route exact path="/compte" component={Tables} />)}
                        {fakeAuth.isAuthenticated && (<Route exact path="/classe" component={Classe} />)}
                        {fakeAuth.isAuthenticated && (<Route exact path="/note" component={Note} />)}
                        {fakeAuth.isAuthenticated && (<Route exact path="/suivi_eval" component={Suivi} />)}
                        {fakeAuth.isAuthenticated && (<Route exact path="/fil_annuel" component={FilAnnuel} />)}

                        {fakeAuth.isAuthenticatedAdmin && (<Route exact path="/dashboard" component={Dashboard} />)}
                        {/*{fakeAuth.isAuthenticatedAdmin === 'true' ? <Route exact path="/settings" component={Settings} /> : <Redirect from="*" to="/" />}*/}
                        {/*{fakeAuth.isAuthenticatedAdmin === 'true' ? <Route exact path="/maps" component={Maps} /> : <Redirect from="*" to="/" />}*/}
                        <Redirect from="*" to="/" />
                    </Switch>
                </ScrollToTop>
            </div>
        </>
    );
}

export default App;
